import $, { ajax } from 'jquery';
import 'jquery-validation'
import('../jquery-validation/localization/messages_' + document.querySelector('html').getAttribute('lang'))

export default class IAForm {
    constructor(
        form,
        needValidation = true,
        validateArray = {
            rules: {},
            submitHandler: new Function,
            messagesIdClass: '',
            isMultipart: false
        }
    ){
        this.form = form
        if(needValidation) {
            let $captcha
            let captcha;
            let isGoogleCaptcha = false;
            // Render captcha if exists
            if ($(form).find('.g-recaptcha').length) {
                isGoogleCaptcha = true;
                $captcha = $(form).find('.g-recaptcha');
                let onloadCallback = function () {
                    captcha = grecaptcha.render($(form).find('.g-recaptcha').attr('id'), {
                        'sitekey': recaptchakey
                    });
                }
            }
            if(isGoogleCaptcha){
                $(form).on('click', '[type="submit"]', function (event) {
                    $captcha.parent('.form-item').find('.validate-error').remove();
                
                    $(form).valid();
                    if ($(form).find('.g-recaptcha') && typeof (grecaptcha) !== 'undefined' && grecaptcha.getResponse(captcha) == "") {
                        $captcha.parent('.form-item').find($captcha).append('<label id="captcha-error" class="validate-error" for="captcha">' + $.validator.messages.required + '</label>');
                        return false;
                    }
                });
            }
            var isFormSubmitted = false;
            $(form).validate({
                rules: validateArray.rules,
                errorPlacement: function(error, element) {
                    var $insertAfter = element.closest('.js-validate-insertafter, .form-aside-checkbox, .form-aside-radio');
                    if($insertAfter.length){
                        error.insertAfter($insertAfter);
                    } else {
                        error.insertAfter(element);
                    }
                },
                invalidHandler: function(form, validator) {
                    setTimeout(function() {
                        $(form.target).find(":input.error:first").focus();
                    }, 100);
                },
                submitHandler: function () {
                    if (isFormSubmitted == true) {
                        return;
                    } else {
                        isFormSubmitted = true;
                        let ajaxOptions = {
                            url: ajaxurl,
                            type: 'POST',
                            success: function (response) {
                                response = JSON.parse(response);
                                response = response.response.replace(/[\r\n\t]/g, "")

                                if (response == 'ok') {
                                    $(form).find(validateArray.messagesIdClass + '-error').attr('aria-hidden', 'true').addClass('is-hidden');
                                    $(form).find(validateArray.messagesIdClass + '-fields').attr('aria-hidden', 'true').addClass('is-hidden');
                                    $(form).find(validateArray.messagesIdClass + '-confirm').attr('aria-hidden', 'false').removeClass('is-hidden');
        
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'GAEvent',
                                        'eventCategory': 'Formulaires',
                                        'eventAction': 'Submit',
                                        'eventLabel': document.title
                                    });
                                } else {
                                    $(form).find(validateArray.messagesIdClass + '-error').attr('aria-hidden', 'false').removeClass('is-hidden');
                                    isFormSubmitted = false;
                                    if ($(form).find('.g-recaptcha') && typeof (grecaptcha) !== 'undefined') {
                                        grecaptcha.reset(captcha);
                                    }
                                }
                            },
                            error: function (xhr, response, errorThrown) {
                                $(form).find(validateArray.messagesIdClass + 'error').attr('aria-hidden', 'false').removeClass('is-hidden');
                                isFormSubmitted = false;
                                if ($(form).find('.g-recaptcha') && typeof (grecaptcha) !== 'undefined') {
                                    grecaptcha.reset(captcha);
                                }
                            }
                        }
                        if (validateArray.isMultipart) {
                            ajaxOptions.data = new FormData(form)
                            ajaxOptions.enctype = 'multipart/form-data'
                            ajaxOptions.processData = false,
                            ajaxOptions.contentType = false
                            ajaxOptions.cache = false
                        } else {
                            ajaxOptions.data = $(form).serialize()
                        }
                        
                        $.ajax(ajaxOptions);
                    }
                }
            });
        }
    }
    formInside(bool = false) {
        if(bool){
            $(this.form).find($(".form-inside")).each(function () {
            var $wrapper = $(this);
            var $input = $wrapper.find("input,textarea,select");
    
            $input
                .on("focusin", function () {
                if (!$input.val()) {
                    $wrapper.removeClass("is-filled");
                }
    
                $wrapper.addClass("is-focus");
                })
                .on("focusout", function () {
                if (!$input.val()) {
                    $wrapper.removeClass("is-focus");
                } else {
                    $wrapper.addClass("is-filled");
                    $wrapper.removeClass("is-focus");
                } if ($input.val() == '') {
                    $wrapper.removeClass("is-filled");
                }
                });
            });
        }
    }
}